<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
        <ConfermaModal
            v-if="confirmDelete"
            :backdrop="false"
            :visible="confirmDelete"
            @reject="confirmDelete = false"
            @confirm="performDelete"
        >
        </ConfermaModal>
    </teleport>

    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-10 flex justify-between items-center">
                <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
                <div class="flex">
                    <NextButton @click="$router.back()" variant="outline-secondary" class="w-44 text-sm py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                    <NextButton component="router-link" v-if="rubrica === 0" :to="{name: 'NuovoCliente'}"
                                variant="primary" class="w-44 ml-3 text-sm py-2 px-4 m-0 hidden sm:block">
                        + Aggiungi
                    </NextButton>
                </div>
            </div>
            <div class="flex justify-between items-center">
                <h3 class="text-3xl font-bold">{{ rubrica === 0 ? "Lista clienti" : "Lista contatti" }}</h3>
                <Switcher v-model="rubrica" :options="['Tutti i clienti', 'Tutti i contatti']" class="my-5"></Switcher>
            </div>

            <div v-if="!rubrica">
                <div class="grid grid-cols-4 gap-4 mb-3">
                    <div class="flex flex-col col-span-2">
                        <Field field_name="Cerca" @update:modelValue="listaAziende.debounceSearch" v-model="listaAziende.search"
                               placeholder="Cerca"></Field>
                    </div>
                </div>
                <div class="flex justify-end">
                    <Paginator :pagination="listaAziende.paginate"></Paginator>
                </div>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 table-fixed w-full border-separate border-spacing-3 py-4"
                               v-model:cols="aziendeCols"
                               :pagination="listaAziende.paginate"
                               :rows="listaAziende.rows" @order-update="listaAziende.updateCols">
                        <template v-for="(c, j) in listaAziende.rows" :key="j" v-slot:[`td_${j}_0`]="{context}">
                            <TableTooltip :inner_class="context.cell.td_class">{{
                                    context.row[context.cell.prop]
                                }}
                            </TableTooltip>
                        </template>
                        <template v-for="(c, j) in listaAziende.rows" :key="j" v-slot:[`td_${j}_1`]="{context}">
                            <TableTooltip :inner_class="context.cell.td_class">{{
                                    context.row[context.cell.prop]
                                }}
                            </TableTooltip>
                        </template>

                        <template v-for="(c, j) in listaAziende.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                            <router-link :to="{name:'DettaglioAzienda', params:{id:context.context.row.id}}"
                                         class="text-center inset-0 absolute flex items-center justify-center"><i
                                class="icon-chevron_destra"></i></router-link>
                        </template>
                        <template v-for="(c, j) in listaAziende.rows" :key="j" v-slot:[`td_${j}_5`]>
                            <TabellaContextMenu
                                menuClass="shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"
                                buttonClass="bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange"
                                :context="c"
                                :id="j"
                                teleport_to="#modal"
                                :cmOpener="cmOpener"
                            >
                                <router-link :to="{name:'Attivita', params: {id:c.id}}"
                                             class="hover:text-next-neu mb-2">Attività
                                </router-link>
                                <router-link :to="{name:'Contatti', params: {id:c.id}}"
                                             class="hover:text-next-neu mb-2">Contatti
                                </router-link>
                                <span v-if="isNewBusiness" @click="cancellaAzienda(c.id)" class="text-next-orange">Elimina</span>
                            </TabellaContextMenu>
                        </template>
                        <template v-for="(c, j) in listaAziende.rows" :key="j" v-slot:[`td_${j}_3`]="context">
                            {{ $filters.toDate(context.context.row.ultimo_contatto) }}
                        </template>
                        <template v-for="(c, j) in listaAziende.rows" :key="j" v-slot:[`td_${j}_2`]="{context}">
                            <div class="grid gap-1"
                                 :style="{'grid-template-columns': `repeat(${businessUnits.length}, minmax(0, 1fr))`}">
                                <div v-for="bu in businessUnits" class="tooltip-activator relative cursor-pointer" :key="bu.id">
                                    <div class="border border-next-neu rounded text-center text-xs">
                                        {{ bu.label }}
                                    </div>
                                    <div :class="`bg-next-${getColoriStati(context.row.stati[bu.id])}`"
                                         class="border rounded text-center text-xs text-white">
                                        {{ getLabel(context.row.stati[bu.id]) }}
                                    </div>
                                    <Tooltip>{{ getTooltip(context.row.stati[bu.id]) }}</Tooltip>
                                </div>
                            </div>
                        </template>
                    </NextTable>

                </div>
                <InfiniteLoading @infinite="listaAziende.fetchNextPage" :identifier="listaAziende.infiniteIdentifier" style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri clienti.</div>
                    </template>
                </InfiniteLoading>
            </div>
            <div v-else>
                <div class="grid grid-cols-4 gap-4 mb-3">
                    <div class="flex flex-col col-span-2">
                        <Field field_name="Cerca" @update:modelValue="listaContatti.debounceSearch" v-model="listaContatti.search"
                               placeholder="Cerca"></Field>
                    </div>
                </div>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4"
                               v-model:cols="contattiCols"
                               :rows="listaContatti.rows"
                               @order-update="listaContatti.updateCols">

                        <template v-for="(c, j) in listaContatti.rows" :key="j" v-slot:[`td_${j}_7`]>
                            <router-link :to="{name:'DettaglioContatto', params:{id:c.cliente_id, cid:c.id}}"
                                         class="text-center inset-0 absolute flex items-center justify-center">
                                <i class="icon-chevron_destra"></i>
                            </router-link>
                        </template>
                    </NextTable>

                </div>
                <InfiniteLoading @infinite="listaContatti.fetchNextPage" :identifier="listaContatti.infiniteIdentifier" style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri contatti.</div>
                    </template>
                </InfiniteLoading>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import AlertCard from "../components/AlertCard.vue";
import Topbar from "../components/Topbar.vue";
import NextTable from "@/components/NextTable.vue";
import Paginator from "@/components/Paginator.vue";
import contattiManager from "../api/Contatti";
import {ColoriStati, LabelStati, NomiStato, Paths, Rubrica, TableOrder} from "@/types";
import {lista_clienti} from "@/BreadcrumbsPath";
import businessUnitsManager from "../api/BusinessUnits";
import InfiniteLoading from "v3-infinite-loading";
import ConfermaModal from "@/components/ConfermaModal.vue";
import ContextMenu from "@/components/ContextMenu.vue";
import Loading from "@/components/Loading.vue";
import {mapGetters} from 'vuex';
import TableTooltip from "@/components/TableTooltip.vue";
import Switcher from "@/components/Switcher.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NextButton from "@/components/NextButton.vue";
import clientiManager from "../api/Clienti";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import Lista from "@/setup/ListaCerca";
import userManager from "../api/Users";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";
import Tooltip from "@/components/Tooltip.vue";

@Options({
    name: 'ListaClienti',
    components: {
        Tooltip,
        Field, MultiselectOption,
        NextButton,
        Switcher,
        Breadcrumbs,
        Topbar,
        AlertCard,
        NextTable,
        Paginator,
        InfiniteLoading,
        ConfermaModal,
        ContextMenu,
        TabellaContextMenu,
        Loading,
        TableTooltip
    },
    computed: {
        ...mapGetters([
            'me',
            'isNewBusiness',
        ])
    }
})
export default class ListaClienti extends Vue {
    cmOpener: any = setup(() => ContextMenuOpener())
    listaAziende: any = setup(()=>Lista(clientiManager, this.aziendeCols))
    listaContatti: any = setup(()=>Lista(contattiManager, this.contattiCols))
    rubrica: Rubrica = Rubrica.CLIENTI


    businessUnits: never[] = []

    loading = false
    cm_visible = -1
    confirmDelete = false
    deleteId = 0

    cancellaAzienda(id: number) {
        this.confirmDelete = true;
        this.deleteId = id;
    }

    performDelete() {
        clientiManager.delete(this.deleteId).then(() => {
            this.listaAziende.reset()
            this.listaContatti.reset()
        }).finally(() => {
            this.confirmDelete = false
        })
    }

    get getBreadcrumbsPath(): Paths[] {
        return lista_clienti
    }

    getColoriStati(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return ColoriStati[ColoriStati.neu]
        }
        return ColoriStati[EnumStato]
    }

    getLabel(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return LabelStati[LabelStati.NEU]
        }
        return LabelStati[EnumStato]
    }

    getTooltip(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return NomiStato[LabelStati.NEU]
        }
        return NomiStato[EnumStato]
    }

    created(): void {
        businessUnitsManager.businessUnits({params:{crm: 1}}).then((response) => {
            this.businessUnits = response.data
        })
    }

    mounted() {
        this.listaAziende.reset()
        this.listaContatti.reset()
    }

    contattiCols = [
        {
            name: 'Nome',
            prop: 'nome',
            orderable: true,
            class: 'text-left min-w-285 whitespace-nowrap',
            td_class: 'px-2 h-10 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Cognome',
            prop: 'cognome',
            orderable: true,
            class: 'text-left min-w-285 whitespace-nowrap',
            td_class: 'px-2 h-10 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Denominazione azienda',
            prop: 'denominazione_cliente',
            orderable: false,
            class: 'text-left min-w-285 w-285 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Posizione lavorativa',
            prop: 'posizione_lavorativa',
            orderable: true,
            class: 'text-left min-w-285 w-285 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Dipartimento',
            prop: 'dipartimento',
            orderable: true,
            class: 'text-left min-w-285 w-285 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Numero di telefono',
            prop: 'telefono_1',
            orderable: false,
            class: 'text-left min-w-200 w-200 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Email',
            prop: 'email',
            orderable: true,
            class: 'text-left min-w-200 w-200 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        }
    ]

    aziendeCols = [
        {
            name: 'Denominazione',
            prop: 'denominazione',
            ordProp: 'anagrafiche_denominazioni.denominazione',
            orderable: true,
            class: 'text-left min-w-350 w-80',
            td_class: 'w-full overflow-visible relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Settore commerciale',
            prop: 'settori_join',
            orderable: false,
            class: 'text-left min-w-350 w-80',
            td_class: 'w-full overflow-visible relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Stato',
            prop: 'denominazione',
            orderable: false,
            class: 'text-left min-w-next-stato w-next-stato whitespace-nowrap',
            td_class: 'bg-transparent',
            resizable: false
        },
        {
            name: 'Ultimo contatto',
            prop: 'created_at',
            orderable: true,
            class: 'text-left min-w-150 w-150 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: 'denominazione',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: 'denominazione',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        }
    ]
}

</script>


<style lang="scss">
.home {
    background-color: green;
}
</style>
